import React from "react";
import * as S from "./styles";

const TermsConditionsCard: React.FC = () => {
  return (
    <S.WrapperProposal style={{ overflow: "auto" }}>
      <S.Title>
        <b>TERMOS E CONDIÇÕES DE USO</b>
      </S.Title>

      <S.Text>
        <p>
          <strong>
            APLICATIVO E WEB CARTÃO TEUCARD E CARTEIRA DIGITAL E FERRAMENTA
            CADASTRO E PROPOSTA{" "}
          </strong>
        </p>

        <p>
          Bem-vindo ao{" "}
          <strong>APLICATIVO E WEB CARTÃO TEUCARD E CARTEIRA DIGITAL</strong>. A
          seguir apresentamos a você (<strong>USUÁRIO</strong>) os Termos e
          Condições de Uso, documento que relaciona as principais regras a serem
          observadas por todos que acessam o{" "}
          <strong>APLICATIVO E WEB CARTÃO TEUCARD E CARTEIRA DIGITAL</strong>,
          que utilizam suas funcionalidades, assim como permitem a consulta dos
          seus dados cadastrais através da{" "}
          <strong>FERRAMENTA CADASTRO E PROPOSTA. </strong>
        </p>

        <p>
          Como condição para acesso e uso das funcionalidades oferecidas pelo{" "}
          <strong>APLICATIVO E WEB CARTÃO TEUCARD E CARTEIRA DIGITAL</strong>, o{" "}
          <strong>USUÁRIO </strong>declara que fez a leitura completa e atenta
          das regras deste documento e de sua Política de Privacidade, estando
          plenamente ciente e de acordo com elas.{" "}
        </p>

        <p>
          <strong>
            1. Informações Gerais sobre o APLICATIVO E WEB CARTÃO TEUCARD E
            CARTEIRA DIGITAL, E A FERRAMENTA CADASTRO E PROPOSTA{" "}
          </strong>
        </p>

        <p>
          1.1.{" "}
          <strong>O APLICATIVO E WEB CARTÃO TEUCARD E CARTEIRA DIGITAL </strong>
          tem como intuito facilitar e complementar a experiência do{" "}
          <strong>USUÁRIO </strong>que possui o <strong>CARTÃO TEUCARD</strong>,
          <strong>bem como, acesso á CARTEIRA DIGITAL</strong>, permitindo, mas
          não se limitando, a obtenção do cartão, visualização de faturas, troca
          de senha, bloqueio e desbloqueio do cartão, detalhamento de gastos,
          realizar transações financeiras eletrônicas dentro do Grupo Nova Era,
          utilizar o TeuClub - Clube de vantangens bem assim demais serviços que
          sejam acrescentados nas plataformas, cuja disponibilização ocorrerá de
          acordo com a conveniência do <strong>TEUCARD</strong>.{" "}
        </p>

        <p>
          1.2. Para acessar o{" "}
          <strong>APLICATIVO E WEB CARTÃO TEUCARD E CARTEIRA DIGITAL </strong>
          de forma segura e utilizar suas funcionalidades, é de inteira
          responsabilidade do <strong>USUÁRIO </strong>dispor de dispositivos e
          equipamentos compatíveis, serviço de conexão à Internet com antivírus
          e <em>firewall </em>habilitados, <em>softwares </em>devidamente
          atualizados – tais como o sistema operacional do dispositivo móvel –,
          além da adoção de medidas de segurança mínimas, o que inclui, mas não
          se limita, a utilização de senha segura.{" "}
        </p>

        <p>
          1.3. O{" "}
          <strong>
            APLICATIVO E WEB CARTÃO TEUCARD, bem como, a CARTEIRA DIGITAL{" "}
          </strong>
          e suas funcionalidades são apresentadas ao <strong>USUÁRIO </strong>na
          maneira como estão disponíveis, podendo passar por constantes
          aprimoramentos e atualizações, obrigando-se o{" "}
          <strong>TEUCARD </strong>a:{" "}
        </p>

        <p>
          (i) Preservar a funcionalidade do{" "}
          <strong>APLICATIVO E WEB CARTÃO TEUCARD</strong>, com botões não
          quebrados e utilizando{" "}
          <strong>
            <em>LAYOUT </em>
          </strong>
          que respeita a usabilidade e navegabilidade, sempre que possível;{" "}
        </p>

        <p>
          (ii) Exibir as funcionalidades de maneira clara, completa, precisa e
          suficiente de modo que exista a exata percepção das operações
          realizadas; e{" "}
        </p>

        <p>
          (iii) Garantir, por meio do estado da técnica disponível, o sigilo dos
          dados inseridos nas funcionalidades oferecidas em seu{" "}
          <strong>APLICATIVO E WEB CARTÃO TEUCARD E CARTEIRA DIGITAL</strong>,
          somente sendo acessíveis pelo <strong>TEUCARD </strong>e por quem o{" "}
          <strong>USUÁRIO </strong>consentir, além de si próprio.{" "}
        </p>

        <p>
          1.4. O <strong>TEUCARD </strong>aplica seus esforços para a
          disponibilidade contínua e permanente do{" "}
          <strong>
            APLICATIVO E WEB CARTÃO TEUCARD, incluindo a CARTEIRA DIGITAL
          </strong>
          . No entanto, pode ocorrer, eventualmente, alguma indisponibilidade
          temporária decorrente de manutenção necessária ou mesmo gerada por
          motivo de força maior, como desastres naturais, falhas ou colapsos nos
          sistemas centrais de comunicação e acesso à Internet ou fatos de
          terceiro que fogem de sua esfera de vigilância e responsabilidade, sem
          que tais eventos gerem qualquer direito compensatório ao{" "}
          <strong>USUÁRIO</strong>, haja vista que temporários.{" "}
        </p>

        <p>
          1.4.1. Se isso ocorrer, o <strong>TEUCARD </strong>fará o que estiver
          ao seu alcance para restabelecer o acesso ao{" "}
          <strong>APLICATIVO E WEB CARTÃO TEUCARD E À CARTEIRA DIGITAL</strong>o
          mais breve possível, dentro das limitações técnicas de seus serviços e
          serviços de terceiros, dos quais o <strong>TEUCARD </strong>depende
          para ficar online.{" "}
        </p>

        <p>
          1.5. Eventuais procedimentos de manutenção serão informados por meio
          dos canais oficiais de comunicação do <strong>TEUCARD </strong>(a
          exemplo, mas não se limitando a, e-mails, notificações no{" "}
          <strong>
            APLICATIVO E WEB CARTÃO TEUCARD, APLICATIVO da CARTEIRA DIGITAL
          </strong>
          , perfis oficiais em mídias sociais ou telefone de atendimento), caso
          seja necessário que este fique indisponível por longos períodos.{" "}
        </p>

        <p>
          <strong>
            2. Funcionalidades do APLICATIVO E WEB CARTÃO TEUCARD{" "}
          </strong>
        </p>

        <p>
          2.1. Os serviços do{" "}
          <strong>
            APLICATIVO E WEB CARTÃO TEUCARD, bem como da CARTEIRA DIGITAL{" "}
          </strong>
          são destinados a pessoas físicas maiores de 18 (dezoito) anos e
          plenamente capazes. Caso o <strong>USUÁRIO </strong>não esteja de
          acordo com o exigido, não deverá prosseguir com a criação da{" "}
          <strong>CONTA DE ACESSO </strong>ou sua utilização, sob pena de ser
          caracterizada má-fé e/ou crime de falsidade ideológica.{" "}
        </p>

        <p>
          2.2. O <strong>TEUCARD </strong>poderá alterar os critérios de
          elegibilidade de acesso e utilização do{" "}
          <strong>APLICATIVO E WEB CARTÃO TEUCARD e da CARTEIRA DIGITAL</strong>
          a qualquer momento, sem que para isso tenha de fazer qualquer tipo de
          comunicação ou aviso prévio ao <strong>USUÁRIO</strong>. O{" "}
          <strong>TEUCARD </strong>também possui a faculdade de se recusar a
          conceder ou cancelar <strong>CONTA DE ACESSO </strong>a qualquer
          pessoa ou entidade que a utilizar de forma fraudulenta, violar ou
          tentar violar os presentes Termos de Uso, O Aviso de Privacidade, o
          Contrato de Adesão ou qualquer documento legal do{" "}
          <strong>TEUCARD</strong>, disponibilizado ou não no{" "}
          <strong>APLICATIVO E WEB CARTÃO TEUCARD e da CARTEIRA DIGITAL</strong>
          .{" "}
        </p>

        <p>
          2.3. Se a qualquer momento for constatado que o{" "}
          <strong>USUÁRIO </strong>forneceu informações falsas ou não
          condizentes com a realidade, o <strong>TEUCARD </strong>se reserva ao
          direito de cancelar sua <strong>CONTA DE ACESSO</strong>, sem prejuízo
          de adotar as medidas que entender cabíveis.{" "}
        </p>

        <p>
          2.4. O <strong>TEUCARD </strong>se reserva ao direito de incluir e
          retirar novas (ou já existentes) funcionalidades e ferramentas do{" "}
          <strong>APLICATIVO E WEB CARTÃO TEUCARD e da CARTIERA DIGITAL</strong>
          segundo sua conveniência, podendo atualizá-lo sempre que entender
          necessário para oferecer os melhores serviços e produtos ao{" "}
          <strong>USUÁRIO</strong>.{" "}
        </p>

        <p>
          2.5. O <strong>USUÁRIO </strong>poderá exercer o seu direito de
          arrependimento em até 07 (sete) dias contados da aquisição de
          determinado produto ou serviço, devendo se utilizar das formas de
          contato disponibilizadas no <strong>CARTÃO TEUCARD </strong>para dar
          início ao procedimento.{" "}
        </p>

        <p>
          <strong>3. Das responsabilidades e obrigações do USUÁRIO</strong>
        </p>

        <p>
          3.1. Utilizar com retidão e de forma ética o{" "}
          <strong>APLICATIVO E WEB CARTÃO TEUCARD e a CARTEIRA DIGITAL</strong>,
          obedecendo aos propósitos aqui estabelecidos, sempre respeitando as
          condições que regem sua utilização e finalidade.{" "}
        </p>

        <p>
          3.2. O <strong>USUÁRIO </strong>se compromete a fornecer dados
          cadastrais corretos, completos e atualizados para que o{" "}
          <strong>APLICATIVO E WEB CARTÃO TEUCARD e a CARTEIRA DIGITAL</strong>
          possa funcionar corretamente, além de informar canal de contato apto a
          ser acionado pelo <strong>TEUCARD </strong>para o melhor cumprimento
          dos serviços.{" "}
        </p>

        <p>
          3.3. Manter o sigilo dos dados de sua{" "}
          <strong>CONTA DE ACESSO </strong>em relação a terceiros, não
          divulgando ou compartilhando sua senha com quem quer que seja,
          inclusive não disponibilizando-a em locais onde outras pessoas possam
          ter acesso ou para aplicativos/softwares acessarem a conta de forma
          automatizada, sob pena de exclusão da <strong>CONTA DE ACESSO</strong>
          , além de ter de ressarcir os danos que sobrevierem dessa divulgação
          indevida. O <strong>USUÁRIO </strong>se obriga a preservar a
          confidencialidade e utilização individual da{" "}
          <strong>CONTA DE ACESSO</strong>.{" "}
        </p>

        <p>
          3.3.1. A <strong>CONTA DE ACESSO </strong>é individual, de uso
          exclusivo e intransferível, portanto o <strong>USUÁRIO </strong>deve
          protegê-la e mantê-la de modo confidencial, não podendo repassá-la a
          terceiros, sob qualquer hipótese, tal qual os componentes de segurança
          adicionais que possuir, conforme descrito acima.{" "}
        </p>

        <p>
          3.4. Adotar senha forte com o intuito de dificultar a ação de{" "}
          <em>experts </em>em computação de adivinhá-la ou quebrá-la por
          mecanismos tecnológicos.{" "}
        </p>

        <p>
          3.4.1. Entende-se por senha forte aquela que não representa sequências
          numéricas ou de fácil dedução e não sejam relacionadas a informações
          pessoais, tais como datas comemorativas, números de telefone, CEP, CPF
          ou repetição de números iguais, a exemplo, mas não se limitando a:
          123456, 000000, 011095 etc.{" "}
        </p>

        <p>
          3.5. Caso o <strong>USUÁRIO </strong>suspeite que a confidencialidade
          de sua senha foi quebrada ou que houve o comprometimento de algum
          dispositivo de autenticação, este deverá proceder a sua troca o mais
          rápido possível. Se não conseguir acessar a Internet para obter
          suporte, deverá buscar o atendimento dentre os canais disponíveis.{" "}
        </p>

        <p>
          3.6. Adotar medidas em seus dispositivos tecnológicos para evitar o
          acesso físico e lógico por terceiros não autorizados, tais como
          utilização de senha.{" "}
        </p>

        <p>
          3.7. O <strong>USUÁRIO </strong>reconhece e afirma que todos os
          acessos realizados após sua autenticação digital bem sucedida são
          interpretados como tendo sido feitos por ele próprio de forma
          incontestável. Por isso, será responsável por todos os acessos e
          operações no{" "}
          <strong>APLICATIVO E WEB CARTÃO TEUCARD e na CARTEIRA DIGITAL</strong>
          praticados com uso de sua <strong>CONTA DE ACESSO</strong>, inclusive
          aqueles derivados de uso indevido ou divulgação desta para terceiros.{" "}
        </p>

        <p>
          3.8. Sempre que não houver contato inicial provocado pelo próprio{" "}
          <strong>USUÁRIO</strong>, então este deve ignorar e/ou rejeitar
          quaisquer espécies de abordagens em nome do <strong>TEUCARD</strong>,
          independentemente do meio utilizado, pela suspeita de que sejam
          falsas, especialmente se consistirem em:{" "}
        </p>

        <p>
          (i) pedido de divulgação, confirmação, conferência ou atualização de
          dados de conta ou informações pessoais;{" "}
        </p>

        <p>
          (ii) requisição, confirmação, conferência ou atualização da{" "}
          <strong>CONTA DE ACESSO</strong>, de componentes de segurança do{" "}
          <strong>USUÁRIO</strong>, ou de dados que estejam contidos nesses
          dispositivos, ou forem os próprios;{" "}
        </p>

        <p>(iii) envio de links de Internet ou arquivos anexos; </p>

        <p>
          (iv) abordagem via mídia social por canal que não seja oficial ou{" "}
        </p>

        <p>
          anúncios em perfis ou páginas estranhas ao <strong>TEUCARD</strong>.{" "}
        </p>

        <p>
          3.9. O dever de cautela e de segurança da informação compete ao
          <strong>USUÁRIO</strong>, qualquer comportamento negligente ou que
          envolva falta de atenção farão com que o <strong>USUÁRIO </strong>
          suporte todos os prejuízos que deu causa, por conta e risco próprio.{" "}
        </p>

        <p>
          3.10. É de responsabilidade do <strong>USUÁRIO </strong>deixar as
          ferramentas de{" "}
          <strong>
            <em>ANTI-SPAM</em>
          </strong>
          , filtros similares ou configurações de redirecionamento de mensagens
          ou notificações ajustadas de modo que não interfiram no recebimento
          dos comunicados e materiais do <strong>TEUCARD</strong>, não sendo
          aceitável nenhuma escusa caso não tenha tido acesso a algum e-mail ou
          mensagem eletrônica em virtude dos recursos mencionados.{" "}
        </p>

        <p>
          3.11. Ao acessar o{" "}
          <strong>APLICATIVO E WEB CARTÃO TEUCARD e a CARTEIRA DIGITAL</strong>,
          o <strong>USUÁRIO </strong>declara que irá respeitar todos os direitos
          de propriedade intelectual de titularidade do <strong>TEUCARD</strong>
          , tal qual todos os direitos referentes a terceiros que porventura
          estejam, ou estiveram, de alguma forma disponíveis no{" "}
          <strong>APLICATIVO E WEB CARTÃO TEUCARD e na CARTEIRA DIGITAL</strong>
          .{" "}
        </p>

        <p>
          3.12. O <strong>USUÁRIO </strong>somente poderá reproduzir os
          conteúdos disponíveis no{" "}
          <strong>APLICATIVO E WEB CARTÃO TEUCARD e na CARTEIRA DIGITAL</strong>
          , em especial suas marcas e <em>layout </em>do ambiente, desde que
          faça a devida citação ou referência ao <strong>TEUCARD</strong>.
        </p>

        <p>
          3.13. As funcionalidades que compõem o{" "}
          <strong>APLICATIVO E WEB CARTÃO TEUCARD e a CARTEIRA DIGITAL</strong>
          são oferecidas na forma de prestação de serviço e licenciamento de
          software, não conferindo ao <strong>USUÁRIO </strong>nenhum direito
          sobre o software utilizado pelo <strong>TEUCARD </strong>ou sobre suas
          estruturas de informática que sustentam o{" "}
          <strong>APLICATIVO E WEB CARTÃO TEUCARD e a CARTEIRA DIGITAL</strong>.{" "}
        </p>

        <p>
          3.14. O <strong>USUÁRIO </strong>é o único e exclusivo responsável
          pelos usos feitos com sua <strong>CONTA DE ACESSO</strong>,
          responsabilizando-se por quaisquer usos que possam violar as
          disposições do <strong>TEUCARD </strong>ou direitos de terceiro.{" "}
        </p>

        <p>
          3.15. O <strong>USUÁRIO </strong>está ciente de que poderá ter sua{" "}
          <strong>CONTA DE ACESSO </strong>banida sem aviso prévio caso a
          utilize para realizar qualquer atividade que viole direitos do{" "}
          <strong>TEUCARD </strong>ou de terceiros.{" "}
        </p>

        <p>
          3.16. Não é permitido o acesso às áreas de programação do{" "}
          <strong>APLICATIVO E WEB CARTÃO TEUCARD e da CARTEIRA DIGITAL</strong>
          , seu banco de dados ou qualquer outro conjunto de informações que
          faça parte da atividade de desenvolvimento.{" "}
        </p>

        <p>
          3.17. Também não é autorizado ao <strong>USUÁRIO </strong>realizar ou
          permitir que se realize engenharia reversa, nem traduzir, decompilar,
          copiar, modificar, reproduzir, alugar, sublicenciar, publicar,
          divulgar, transmitir, emprestar, distribuir ou, de outra maneira,
          dispor das ferramentas do{" "}
          <strong>APLICATIVO E WEB CARTÃO TEUCARD </strong>e de suas
          funcionalidades.{" "}
        </p>

        <p>
          3.18. No
          <strong>APLICATIVO E WEB CARTÃO TEUCARD e na CARTEIRA DIGITAL</strong>
          é proibida a utilização de qualquer tipo ou espécie de técnica de
          mineração de dados, além de qualquer software que atue de modo
          automatizado, tanto para realizar operações massificadas ou para
          quaisquer outras finalidades.{" "}
        </p>

        <p>
          3.19. O <strong>USUÁRIO </strong>declara que não utilizará de técnicas
          para mascarar,esconder, alterar ou falsear seu endereço de IP
          (Internet Protocol) durante seu acesso ou tentativa de acesso ao{" "}
          <strong>APLICATIVO E WEB CARTÃO TEUCARD e à CARTEIRA DIGITAL</strong>,
          incluindo interferir no funcionamento regular do acesso entre seu
          dispositivo e os servidores do{" "}
          <strong>APLICATIVO E WEB CARTÃO TEUCARD e da CARTEIRA DIGITAL</strong>
          ou explorar suas eventuais vulnerabilidades.{" "}
        </p>

        <p>
          3.20.O <strong>USUÁRIO </strong>também não usará qualquer VPN para
          acesso ao{" "}
          <strong>
            APLICATIVO E WEB CARTÃO TEUCARD e à CARTEIRA DIGITAL.{" "}
          </strong>
        </p>

        <p>
          3.21. O descumprimento de quaisquer das obrigações aqui estipuladas
          poderá acarretar suspensão das funcionalidades ou exclusão da{" "}
          <strong>CONTA DE ACESSO </strong>do <strong>USUÁRIO</strong>, conforme
          previsto neste documento.{" "}
        </p>

        <p>
          3.22. A eventual remoção, bloqueio ou suspensão de qualquer conteúdo
          ou funcionalidade do
          <strong>APLICATIVO E WEB CARTÃO TEUCARD e da CARTEIRA DIGITAL</strong>
          em decorrência de alguma reclamação, deverá ser sempre compreendida
          como demonstração de boa-fé e intenção de solução amigável de
          conflitos, jamais como reconhecimento de culpa ou de qualquer infração
          pelo <strong>TEUCARD </strong>a direito de terceiro.{" "}
        </p>

        <p>
          3.23. Na incidência de danos ao{" "}
          <strong>APLICATIVO E WEB CARTÃO TEUCARD e à CARTEIRA DIGITAL</strong>
          ou a terceiros, o responsável se compromete a arcar com todas as
          obrigações de indenizar o sujeito lesado.{" "}
        </p>

        <p>
          3.24. O <strong>USUÁRIO </strong>se obriga a ressarcir o{" "}
          <strong>TEUCARD </strong>de todas as condenações e prejuízos que
          sofrer cuja origem for de atos praticados por sua{" "}
          <strong>CONTA DE ACESSO</strong>, assumindo o polo passivo de ação
          judicial ou procedimento administrativo e requerendo a exclusão do{" "}
          <strong>TEUCARD</strong>, inclusive, devendo arcar totalmente com as
          despesas e custas processuais atinentes, deixando-a livre de prejuízos
          e ônus.{" "}
        </p>

        <p>
          <strong>
            4. Da isenção e limitações de Responsabilidade do TEUCARD{" "}
          </strong>
        </p>

        <p>
          4.1. O{" "}
          <strong>APLICATIVO E WEB CARTÃO TEUCARD e a CARTEIRA DIGITAL</strong>
          tem como intuito facilitar e complementar a experiência do{" "}
          <strong>USUÁRIO </strong>que possui o{" "}
          <strong>
            CARTÃO TEUCARD e adere ao TeuClub - Clube de vantagens, bem como,
            acesso à CARTEIRA DIGITAL
          </strong>
          .{" "}
        </p>

        <p>
          4.2. O <strong>TEUCARD </strong>não se responsabiliza por quaisquer
          problemas, <em>bugs </em>ou funcionamentos indevidos que ocorrerem nos
          dispositivos e equipamentos do USUÁRIO e sejam resultantes do uso
          regular do{" "}
          <strong>APLICATIVO E WEB CARTÃO TEUCARD e da CARTEIRA DIGITAL</strong>
          .{" "}
        </p>

        <p>
          4.3. O <strong>TEUCARD </strong>não garante e nem se responsabiliza
          pela disponibilidade integral e ininterrupta do{" "}
          <strong>APLICATIVO E WEB CARTÃO TEUCARD e da CARTEIRA DIGITAL</strong>
          , cujo correto funcionamento depende do acesso e tráfego de dados
          entre os dispositivos do <strong>USUÁRIO </strong>e os servidores do{" "}
          <strong>APLICATIVO E WEB CARTÃO TEUCARD e da CARTEIRA DIGITAL</strong>
          , não possuindo o <strong>TEUCARD </strong>nenhuma ingerência e não
          sendo responsável por eventuais falhas no tráfego destes dados e no
          acesso ao <strong>APLICATIVO E WEB CARTÃO TEUCARD </strong>decorrentes
          de falhas na Internet ou da própria rede e serviços de telecomunicação
          prestados por provedores de acesso à Internet.{" "}
        </p>

        <p>
          4.4. O <strong>TEUCARD </strong>não se responsabiliza por qualquer
          dano direto ou indireto ocasionado por eventos de terceiros, como
          ataque de <em>hackers</em>, falhas no sistema, no servidor ou na
          conexão à internet, inclusive por ações de <em>softwares </em>
          maliciosos como vírus, cavalos de Tróia, e outros que possam, de algum
          modo, danificar o dispositivo ou a conexão do{" "}
          <strong>USUÁRIO </strong>em decorrência do acesso, utilização ou
          navegação no{" "}
          <strong>APLICATIVO E WEB CARTÃO TEUCARD e na CARTEIRA DIGITAL</strong>
          , bem como a transferência de dados, arquivos, imagens, textos, áudios
          ou vídeos contidos neste.{" "}
        </p>

        <p>
          4.5. O <strong>USUÁRIO </strong>não possui qualquer direito para
          exigir a disponibilidade{" "}
          <strong>APLICATIVO E WEB CARTÃO TEUCARD e da CARTEIRA DIGITAL</strong>
          conforme melhor lhes convém, tampouco poderá pleitear indenização ou
          reparação de danos em caso do{" "}
          <strong>APLICATIVO E WEB CARTÃO TEUCARD e da CARTEIRA DIGITAL</strong>
          permanecer fora do ar, independente da motivação.
        </p>

        <p>
          <strong>5. Segurança </strong>
        </p>

        <p>
          5.1. Os dados e informações serão obtidos quando o{" "}
          <strong>USUÁRIO</strong>:{" "}
        </p>

        <p>
          (i) Efetuar cadastro no{" "}
          <strong>APLICATIVO E WEB CARTÃO TEUCARD</strong>;{" "}
        </p>
        <p>
          (ii) Efetuar cadastro no{""}
          <strong>APLICATIVO CARTEIRA DIGITAL</strong>;{""}
        </p>
        <p>
          (iii) Efetuar cadastro no TeuClub - Clube de
          vantagens(https://www.clubeteucard.com/);
        </p>
        <p>
          (iv) Interagir com as ferramentas existentes no{" "}
          <strong>APLICATIVO E WEB </strong>
        </p>

        <p>
          <strong>CARTÃO TEUCARD e na CARTEIRA DIGITAL</strong>, fornecendo as
          informações voluntariamente;{" "}
        </p>

        <p>
          (v) Entrar em contato por meio dos canais de comunicação disponíveis{" "}
        </p>

        <p>
          no <strong>TEUCARD</strong>.{" "}
        </p>

        <p>
          (vi) Solicitar análise de proposta através da{" "}
          <strong>FERRAMENTA CADASTRO E PROPOSTA, </strong>seja presencialmente
          ou através de meios digitais<strong>. </strong>
        </p>

        <p>5.2. Os dados serão armazenados da seguinte forma: </p>

        <p>
          (i) Todos os dados e informações coletados do{" "}
          <strong>USUÁRIO </strong>serão administrados e mantido pela OPAH IT
          Consulting, empresa terceira parceira do <strong>TEUCARD</strong>.{" "}
        </p>

        <p>
          (ii) Os dados e informações coletados estarão armazenados em ambiente
          seguro, observado o estado da técnica disponível, e somente poderão
          ser acessadas por pessoas qualificadas e autorizadas pelo{" "}
          <strong>TEUCARD</strong>.{" "}
        </p>

        <p>
          (iii) Considerando que nenhum sistema de segurança é absolutamente
          seguro, o <strong>TEUCARD </strong>se exime de quaisquer
          responsabilidades por eventuais danos e/ou prejuízos decorrentes de
          falhas, vírus ou invasões do banco de dados do{" "}
          <strong>APLICATIVO E WEB TEUCARD</strong>, assim como da{" "}
          <strong>FERRAMENTA CADASTRO E PROPOSTA, </strong>salvo nos casos de
          dolo ou culpa.{" "}
        </p>

        <p>
          <strong>6. Uso dos dados e informações </strong>
        </p>

        <p>
          6.1. Os dados e informações coletados do USUÁRIO poderão ser
          utilizados para as seguintes finalidades:{" "}
        </p>

        <p>
          (i) Efetuar a entrega e cobrança de qualquer produto adquirido por
          meio do <strong>APLICATIVO E WEB TEUCARD</strong>, assim como a
          identificação do respectivo destinatário;{" "}
        </p>

        <p>
          (ii) Responder a eventuais dúvidas e solicitações do{" "}
          <strong>USUÁRIO</strong>;{" "}
        </p>

        <p>
          (iii) Fornecer acesso ao <strong>APLICATIVO E WEB TEUCARD</strong>;{" "}
        </p>

        <p>
          (iv) Fornecer acesso ao <strong>APLICATIVO CARTEIRA DIGITAL</strong>;{" "}
        </p>
        <p>
          (v) v) Permitir a utilização dos benefícios/vantagens disponibilizadas
          pelo TeuClub - Clube de vantagens{""}
        </p>

        <p>(vi) Cumprimento de ordem legal ou judicial; </p>

        <p>
          (vii) Constituir, defender ou exercer regularmente direitos em âmbito
          judicial ou administrativo;{" "}
        </p>

        <p>
          (vii) Elaborar relatórios, para identificação do perfil dos{" "}
          <strong>USUÁRIOS </strong>e desenvolvimento de campanhas do{" "}
          <strong>TEUCARD</strong>;{" "}
        </p>

        <p>
          (ix) Manter atualizados os cadastros para fins de contato por
          telefone, correio eletrônico, SMS e por outros meios de comunicação;
        </p>

        <p>6.2. Confidencialidade e Política de Privacidade: </p>

        <p>
          (i) <strong>TEUCARD </strong>se compromete a manter sigilosas as
          informações recebidas do <strong>USUÁRIO</strong>. Dessa forma, não
          pode, sob qualquer condição, usá-las para finalidade distinta da
          execução destes Termos e Condições de Uso, divulgá-las, revelá-las ou
          ainda as reproduzir, sem a validação expressa do{" "}
          <strong>USUÁRIO</strong>. Exclui-se da vedação aqui prevista, a
          divulgação decorrente de determinação de autoridades competentes.
        </p>

        <p>
          (ii) O <strong>USUÁRIO </strong>declara-se de acordo com a prestação
          de informações por parte do <strong>TEUCARD</strong>, mesmo que
          referente a seu cadastro, conta ou transações efetuadas através do
          aplicativo eletrônico e os meios de pagamento a qual façam jus, a
          órgãos públicos, como o COAF, Delegacias de Polícia e Secretarias da
          Receita Estadual e Federal.
        </p>

        <p>
          (iii) O <strong>USUÁRIO </strong>declara-se de acordo e autoriza{" "}
          <strong>TEUCARD </strong>a utilizar as informações, mesmo que
          confidenciais, para criação de banco de dados, respeitando a
          individualidade e identificação de cada <strong>USUÁRIO</strong>,
          observadas as normas relativas à proteção dos dados.{" "}
        </p>

        <p>
          (iv) Com o intuito de melhorar os serviços e a experiência do{" "}
          <strong>USUÁRIO</strong>, o <strong>TEUCARD </strong>poderá coletar e
          utilizar informações sobre o desempenho dos serviços, do computador e
          do uso das funcionalidades pelo <strong>USUÁRIO</strong>,
          preservando-se a individualidade e identificação de cada{" "}
          <strong>USUÁRIO</strong>.{" "}
        </p>

        <p>
          (v) O dever de confidencialidade aqui estipulado permanecerá vigente
          por prazo indeterminado, mesmo após o término deste contrato, enquanto
          as informações confidenciais não se tornarem domínio público e
          mantiverem seu potencial nocivo.{" "}
        </p>

        <p>
          (vi) O <strong>USUÁRIO</strong>, ao realizar o acesso no{" "}
          <strong>APLICATIVO E WEB CARTÃO TEUCARD e na CARTEIRA DIGITAL</strong>
          , autoriza <strong>TEUCARD </strong>e declara-se ciente de que as
          informações coletadas durante o uso do App, web site, são de única e
          exclusiva necessidade referente à execução do próprio sistema. As
          informações poderão ser armazenadas, processadas ou acessadas desde
          que seja respeitada a legislação brasileira, em especial, a Lei no
          12.965/14 (“Marco Civil da Internet”), o Decreto no 8.771, de 11/05/16
          (“Decreto”), Lei no 13.709/18 e legislação superveniente que disponha
          sobre a proteção dos dados.{" "}
        </p>

        <p>
          (vii) <strong>TEUCARD </strong>poderá compartilhar essa informação com
          provedores de serviços que se integrem dentro da Plataforma ou por
          outros links a outros sites eletrônicos da Internet, para atender
          necessidades dos <strong>USUÁRIO </strong>relacionadas aos Serviços de
          Gerenciamento de dados.{" "}
        </p>

        <p>
          (viii) Toda informação pessoal será transmitida por meio de uma página
          de Internet segura, que protege e encripta a informação. A informação
          pessoal será armazenada em servidores ou meios magnéticos que mantêm
          altos padrões de segurança. <strong>TEUCARD </strong>empregará seus
          melhores esforços para manter a confidencialidade e segurança de que
          trata esta seção, mas não responderá por prejuízos que possam derivar
          da violação destas medidas por parte de terceiros que utilizem as
          redes públicas ou a Internet para acessar esta informação. Ficam
          excetuadas do disposto nesta cláusula as circunstâncias em que a{" "}
          <strong>TEUCARD </strong>constitua parceria com outras empresas para
          oferecer serviços de valor agregado a seus <strong>USUÁRIOS</strong>.
        </p>

        <p>
          <strong>7. LEI GERAL DE PROTEÇÃO DE DADOS (LGPD) </strong>
        </p>

        <p>
          7.1. Por meio desta cláusula, e em conformidade com o AVISO DE
          PRIVACIDADE vigente, o <strong>USUÁRIO </strong>declara ciência e seu
          EXPRESSO CONSENTIMENTO para o <strong>TEUCARD </strong>coletar e
          armazenar os seus dados quando julgar necessário.{" "}
        </p>

        <p>
          7.2. O <strong>USUÁRIO </strong>autoriza a coleta de dados pessoais
          imprescindíveis a execução deste contrato, tendo sido informado quanto
          ao tratamento de dados que será realizado pelo{" "}
          <strong>TEUCARD</strong>, nos termos da Lei n° 13.709/2018,
          especificamente quanto a coleta dos seguintes dados:{" "}
        </p>

        <p>a) Nome completo; </p>

        <p>b) Data de nascimento; </p>

        <p>c) Estado Civil; </p>

        <p>d) Número e imagem da Carteira de Identidade (RG); </p>

        <p>e) Número e imagem da Carteira Nacional de Habilitação (CNH);</p>

        <p>f) Número e imagem do Cadastro de Pessoas Físicas (CPF); </p>

        <p>g) Endereço completo; </p>

        <p>h) Números de telefone, WhatsApp e endereços de e-mail; </p>

        <p>i) Profissão e Renda presumida; </p>

        <p>j) Fotografia do rosto (autoretrato); </p>

        <p>k) Nome e telefone de referência(s) pessoal(is). </p>

        <p>l) Dados bancários e de Cartões de Crédito.</p>

        <p>
          7.3. Finalidade do tratamento de dados: O <strong>USUÁRIO </strong>
          autoriza que o <strong>TEUCARD </strong>utilize os dados pessoais e
          dados pessoais sensíveis listados neste contrato para as seguintes
          finalidades:{" "}
        </p>

        <p>a) Possibilitar a execução do presente contrato; </p>

        <p>
          b) Possibilitar que o <strong>TEUCARD </strong>identifique o{" "}
          <strong>USUÁRIO</strong>;{" "}
        </p>

        <p>
          c) Possibilitar que o <strong>TEUCARD </strong>entre em contato com o{" "}
          <strong>USUÁRIO </strong>
        </p>

        <p>quando necessário; </p>

        <p>
          d) Possibilitar que o <strong>TEUCARD </strong>elabore contratos
          comerciais e emita{" "}
        </p>

        <p>
          cobranças contra o <strong>USUÁRIO</strong>;{" "}
        </p>

        <p>e) Proporcionar a melhor experiência e suporte; </p>

        <p>f) Cumprir as obrigações legais e regulatórias; </p>

        <p>g) Gerar um maior grau de segurança e autenticidade; </p>

        <p>h) Aprimoramento dos serviços prestados; </p>

        <p>i) Prevenção e resolução de problemas técnicos ou de segurança; </p>

        <p>
          j) Exercício regular de direitos do <strong>TEUCARD</strong>;{" "}
        </p>

        <p>k) Cumprimento de ordem judicial, de autoridade competente ou de </p>

        <p>órgão fiscalizador; </p>

        <p>l) Fornecer produtos ou informar promoções; </p>

        <p>
          m) Reconhecimento facial para identificar e autenticar os contatos e{" "}
        </p>

        <p>TRANSAÇÕES realizadas pelo PORTADOR TITULAR. </p>

        <p>
          7.4. <strong>Compartilhamento de dados: </strong>Os dados coletados
          poderão ser utilizados para identificação de terrorismo,
          compartilhamento para órgãos de segurança, conforme solicitação legal
          pertinente, compartilhamento com autoridade administrativa e judicial
          no âmbito de suas competências com base no estrito cumprimento do
          dever legal, bem como com os órgãos de proteção ao crédito a fim de
          garantir a adimplência do <strong>USUÁRIO </strong>perante o{" "}
          <strong>TEUCARD. </strong>
        </p>

        <p>
          7.5. O <strong>USUÁRIO </strong>poderá registrar e gravar todos os
          dados fornecidos em toda comunicação realizada com a sua equipe, seja
          por correio eletrônico, mensagens, telefone ou qualquer outro meio.{" "}
        </p>

        <p>
          7.6. Os dados coletados com base no legítimo interesse do{" "}
          <strong>USUÁRIO</strong>, bem como para garantir a fiel execução do
          contrato por parte do <strong>TEUCARD</strong>, fundamentam-se no
          artigo 7o da LGPD.{" "}
        </p>

        <p>
          7.7.
          <strong>
            O USUÁRIO autoriza o compartilhamento de seus dados com o banco de
            dados do programa denominado ZEUSS APP, pois este programa controla
            o benefício denominado <em>cashback </em>disponibilizado ao USUÁRIO.{" "}
          </strong>
        </p>

        <p>
          7.7.1 ZEUSS APP é um programa de recompensas, fidelidade e carteira
          digital desenvolvido pela Clientar LTDA., pessoa jurídica de direito
          privado inscrita no CNPJ/ME sob no 35.872.830/0001-93, com sede na
          cidade de Manaus, Estado do Amazonas.{" "}
        </p>

        <p>
          7.7.2 Após aceite eletrônico dos presentes termos de uso, o{" "}
          <strong>USUÁRIO </strong>concorda com a adesão ao referido programa de
          recompensas (ZEUSS APP).{" "}
        </p>

        <p>
          7.8.
          <strong>
            O USUÁRIO autoriza o compartilhamento de seus dados com o banco de
            dados do programa denominado TEUCLUB, pois este programa concede
            vantagens e/ou benefícios aos clientes do TEUCARD por meio das mais
            diversas parcerias em estabelecimentos comerciais
          </strong>
        </p>
        <p>
          7.8.1. O TEUCLUB é uma plataforma <em>whitelabel</em> gerida pela
          empresa LOOPMAIS TECNOLOGIA DIGITAL LTDA, pessoa jurídica de direito
          privado, inscrita no CNPJ: 41.685.429/0001-47, com Sede em São
          Paulo/SP .
        </p>
        <p>
          7.8.2. Após aceite eletrônico dos presentes termos de uso, o{" "}
          <strong>USUÁRIO</strong>
          concorda com a adesão ao referido programa de vantagens (TEUCLUB).
        </p>
        <p>
          7.9. <strong>Responsabilidade pela Segurança dos dados: </strong>o{" "}
          <strong>TEUCARD </strong>se responsabiliza por manter medidas de
          segurança, técnicas e administrativas suficientes a proteger os dados
          pessoais do Titular e à Autoridade Nacional de Proteção de Dados
          (ANPD), comunicando ao Titular, caso ocorra algum incidente de
          segurança que possa acarretar risco ou dano relevante, conforme artigo
          48 da Lei n° 13.709/2020.{" "}
        </p>

        <p>
          7.10. <strong>Exclusão dos dados: </strong>Será efetuada sem que haja
          prejuízo por parte do <strong>TEUCARD</strong>, para tanto, caso o{" "}
          <strong>USUÁRIO </strong>deseje efetuar a revogação de algum dado,
          deverá preencher uma declaração neste sentido, ciente que a revogação
          de determinados dados poderá importar em eventuais prejuízos na
          prestação de serviços.{" "}
        </p>

        <p>
          7.11. <strong>Término do Tratamento de dados: </strong>Ao{" "}
          <strong>TEUCARD </strong>é permitido manter e utilizar os dados
          pessoais do Titular durante todo o período contratualmente firmado
          para as finalidades relacionadas nesse termo e ainda após o término da
          contratação, pelo prazo de 05 (cinco) anos, para cumprimento de
          obrigação legal ou impostas por órgãos de fiscalização, nos termos do
          artigo 16 da Lei n° 13.709/2018. Dados pessoais anonimizados, sem
          possibilidade de associação ao indivíduo, poderão ser mantidos por
          período indefinido{" "}
        </p>

        <p>
          7.12. O <strong>USUÁRIO </strong>autoriza, neste mesmo ato, a guarda
          dos documentos (contratos/documentos pessoais ou
          fiscais/notificações/ordens de serviços) - em que pese eles possuam
          dados pessoais - por parte do EMISSOR a fim de que ele cumpra com o
          determinado nas demais normas que regulam o presente contrato, bem
          como para o cumprimento da obrigação legal nos termos do artigo 16,
          inciso I, da Lei Geral de Proteção de Dados.{" "}
        </p>

        <p>
          7.13. O <strong>TEUCARD </strong>informa que a gerência de dados
          ocorrerá através de um sistema que colherá e tratará os dados na forma
          da lei.{" "}
        </p>

        <p>
          7.14. O <strong>TEUCARD </strong>informa que efetuará a manutenção do
          registro das operações de tratamento de dados pessoais da forma
          mencionada na cláusula anterior{" "}
        </p>

        <p>
          7.15. Rescindido o contrato os dados pessoais coletados serão
          armazenados pelo tempo determinado na cláusula 7.11.{" "}
        </p>

        <p>
          7.16. Passado o termo de guarda pertinente ao{" "}
          <strong>TEUCARD </strong>se compromete a efetuar o descarte dos dados
          adequadamente.{" "}
        </p>

        <p>
          7.17. O <strong>USUÁRIO </strong>poderá entrar em contato com o
          encarregado pelos seus dados através do e-mail: sac@useteucard.com.br.
        </p>

        <p>
          7.18. <strong>Seus direitos: </strong>O <strong>USUÁRIO </strong>tem
          direito a obter do <strong>TEUCARD</strong>, em relação aos dados por
          ele tratados, a qualquer momento, e mediante requisição, conforme
          previsão do art. 18 da LGPD:{" "}
        </p>

        <p>a) Solicitar confirmação da existência de tratamento; </p>

        <p>b) Acessar seus dados pessoais; </p>

        <p>c) Solicitaracorreçãodedadosincompletos,inexatosoudesatualizado;</p>

        <p>d) Solicitar anonimização, bloqueio ou eliminação de dados </p>

        <p>desnecessários, excessivos ou tratados em desconformidade com o </p>

        <p>disposto na LGPD; </p>

        <p>
          e) Solicitar a portabilidade dos dados a outro fornecedor de serviço
          ou{" "}
        </p>

        <p>
          produto, mediante requisição expressa, de acordo com a regulamentação
          da autoridade nacional, observados os segredos comercial e industrial;{" "}
        </p>

        <p>
          f) Solicitar a eliminação dos dados pessoais tratados com o seu
          consentimento, exceto nas hipóteses previstas neste termo e no artigo
          16 da LGPD;{" "}
        </p>

        <p>
          g) Solicitarinformaçãodasautoridadespúblicaseprivadascomasquais o
          controlador realizou uso compartilhado de dados;{" "}
        </p>

        <p>
          h) Obter informações sobre a possibilidade de não fornecer
          consentimento e sobre as consequências da negativa; e{" "}
        </p>

        <p>
          i) Revogação do consentimento, nos termos do § 5o do art. 8o da Lei no
          13.709, de 2018.{" "}
        </p>

        <p>
          7.19. O consentimento conferido por meio deste instrumento particular
          poderá ser revogado a qualquer momento pelo(a){" "}
          <strong>USUÁRIO</strong>, mediante sua manifestação expressa, por meio
          de solicitação via correio eletrônico (e-mail) ou por correspondência
          encaminhada ao <strong>TEUCARD</strong>, ratificados os tratamentos
          realizados sob amparo do presente consentimento, nos termos do inciso
          VI do “caput” do art. 18 da Lei no 13.709, de 2018.{" "}
        </p>

        <p>
          <strong>8. Disposições Gerais </strong>
        </p>

        <p>
          8.1. O <strong>USUÁRIO </strong>deverá entrar em contato em caso de
          qualquer dúvida com relação às disposições constantes destes Termos de
          Uso por meio dos canais de atendimento do <strong>TEUCARD </strong>
          apontados a seguir:{" "}
        </p>

        <p>
          (i) Atendimento eletrônico: 24 horas por dia, 7 dias por semana,
          através do <strong>APLICATIVO E WEB CARTÃO TEUCARD</strong>;{" "}
        </p>

        <p>
          (ii) Atendimento eletrônico: 24 horas por dia, 7 dias por semana,
          através do <strong>APLICATIVO CARTEIRA DIGITAL</strong>;
        </p>

        <p>
          (iii) Atendimento presencial: De segunda a sábado, em horário
          comercial, nos estandes disponíveis nas lojas Nova Era na cidade de
          Manaus-Am;
        </p>

        <p>
          (iv) Central telefônica: Em horário comercial, pelo número 4003-3203;{" "}
        </p>

        <p>(v) Formulário Eletrônico: disponível na página de atendimento </p>

        <p>
          (acessível pelo <em>link http://</em>www.useteucard.com.br);{" "}
        </p>

        <p>(vi) Correio Eletrônico: Através do endereço de e-mail </p>

        <p>sac@useteucard.com.br. </p>

        <p>
          8.2. Os presentes Termos de Uso e Condições estão sujeitos a constante
          melhoria e aprimoramento. Assim, o <strong>TEUCARD </strong>se reserva
          ao direito de modificá-los a qualquer momento, conforme a finalidade
          do{" "}
          <strong>
            APLICATIVO, WEB CARTÃO TEUCARD, bem como, da CARTEIRA DIGITAL E
            FERRAMENTA DE CADASTRO E PROPOSTA{" "}
          </strong>
          ou conveniência de sua controladora, tal qual para adequação e
          conformidade legal de disposição de lei ou norma que tenha força
          jurídica equivalente, cabendo ao <strong>USUÁRIO </strong>verificá-lo
          sempre que efetuar o acesso ao{" "}
          <strong>APLICATIVO E WEB CARTÃO TEUCARD e à CARTEIRA DIGITAL</strong>.{" "}
        </p>

        <p>
          8.3. Ao navegar pelo{" "}
          <strong>
            APLICATIVO E WEB CARTÃO TEUCARD e pela CARTEIRA DIGITAL
          </strong>
          e utilizar suas funcionalidades, o <strong>USUÁRIO </strong>aceita
          guiar-se pelos Termos de Uso e Condições que se encontram vigentes na
          data de acesso. Por isso, é recomendável que o{" "}
          <strong>USUÁRIO </strong>se mantenha atualizado.{" "}
        </p>

        <p>
          8.4. A tolerância do eventual descumprimento de quaisquer das
          cláusulas e condições do presente instrumento não constituirá novação
          das obrigações aqui estipuladas e tampouco impedirá ou inibirá a
          exigibilidade das mesmas a qualquer tempo.{" "}
        </p>

        <p>8.5. Caso alguma disposição destes Termos de Uso publicadas no </p>

        <p>
          <strong>
            APLICATIVO, WEB CARTÃO TEUCARD, CARTEIRA DIGITAL E FERRAMENTA DE
            CADASTRO E PROPOSTA{" "}
          </strong>
          for julgada inaplicável ou sem efeito, o restante do documento
          continua em vigor, sem a necessidade de medida judicial que declare
          tal assertiva.{" "}
        </p>

        <p>
          8.6. O{" "}
          <strong>
            APLICATIVO, WEB CARTÃO TEUCARD, CARTEIRA DIGITAL E FERRAMENTA DE
            CADASTRO E PROPOSTA{" "}
          </strong>
          tem como base a data e horários oficiais de Manaus/AM.{" "}
        </p>

        <p>
          <strong>9. Lei aplicável e Jurisdição </strong>
        </p>

        <p>
          9.1. Os Termos e Condições de Uso aqui descritos são interpretados
          segundo a legislação brasileira, no idioma português, sendo eleito o
          foro do domicílio do <strong>TEUCARD </strong>para dirimir qualquer
          litígio ou controvérsia envolvendo o presente documento, salvo
          ressalva específica de competência pessoal, territorial ou funcional
          pela legislação aplicável.{" "}
        </p>

        <p>
          <strong>10. Glossário </strong>
        </p>

        <p>
          10.1. Para os fins deste documento, devem se considerar as seguintes
          definições e descrições para seu melhor entendimento:{" "}
        </p>

        <p>
          (I){" "}
          <strong>
            <em>ANTI-SPAM</em>
          </strong>
          : Sistema que evita correspondências não desejadas, como publicidade
          em massa, pelo bloqueio de mensagens ou as movendo para pasta
          específica.{" "}
        </p>

        <p>
          (II) <strong>APLICATIVO E WEB CARTÃO TEUCARD: </strong>Plataforma
          digital disponibilizada ao <strong>USUÁRIO </strong>que pode ser
          acessada a partir de aplicativo <em>mobile </em>ou através de site
          eletrônico da <em>Internet</em>.{" "}
        </p>

        <p>
          (III) <strong>CARTÃO TEUCARD</strong>: Cartão <em>Private Label </em>
          emitido pelo <strong>TEUCARD</strong>.{" "}
        </p>

        <p>
          (IV) <strong>CARTEIRA DIGITAL</strong>: Dispositivo eletrônico que
          permite que o<strong>USUÁRIO</strong> faça transações financeiras
          eletrônicas dentro do Grupo Nova Era.
        </p>

        <p>
          (V) <strong>CONTA DE ACESSO</strong>: Credencial de um{" "}
          <strong>USUÁRIO </strong>que permite acesso ao{" "}
          <strong>APLICATIVO E WEB CARTÃO TEUCARD</strong>, definida pela
          combinação de CPF e senha, e consistente nas informações pessoais
          fornecidas pelo <strong>USUÁRIO</strong>.{" "}
        </p>

        <p>
          (VI) <strong>FERRAMENTA CADASTRO E PROPOSTA: </strong>Plataforma
          digital para captura de dados pessoais do <strong>USUÁRIO </strong>com
          intuito de proceder a análise de crédito e sendo aprovado, conceder um{" "}
          <strong>CARTÃO TEUCARD</strong>.{" "}
        </p>

        <p>
          (VII){" "}
          <strong>
            <em>LAYOUT</em>
          </strong>
          : Conjunto compreendido entre aparência, <em>design </em>e fluxos do{" "}
          <strong>
            APLICATIVO, WEB CARTÃO TEUCARD E FERRAMENTA DE CADASTRO E PROPOSTA.{" "}
          </strong>
        </p>

        <p>
          (VIII){" "}
          <strong>
            <em>LINK</em>
          </strong>
          : Terminologia para endereço de <em>Internet</em>.{" "}
        </p>

        <p>
          (IX)<strong>TEUCARD: </strong>MERCANTIL NOVA ERA LTDA, pessoa jurídica
          de direito privado, inscrita no CNPJ sob o no. 04.240.370/0001-57, com
          sede na Av. Torquato Tapajós, 2871, CEP: 69.048-010, Manaus/AM.{" "}
        </p>

        <p>
          (X) <strong>USUÁRIO</strong>: Pessoa que acessa ou interage com as
          atividades oferecidas pelo{" "}
          <strong>
            APLICATIVO, WEB CARTÃO TEUCARD E FERRAMENTA CADASTRO E PROPOSTA.{" "}
          </strong>
        </p>

        <p>
          (XI) <strong>TEUCLUB</strong>: Clube de vantagens que o cliente
          TEUCARD tem direito ao aderir ao Cartão.
        </p>

        <p>
          <strong>Atualização: </strong>20 de abril de 2023{" "}
        </p>
      </S.Text>
    </S.WrapperProposal>
  );
};

export default TermsConditionsCard;
